// extracted by mini-css-extract-plugin
export default {"loading":"admin_loading__0bkKY","sessionUrl":"admin_sessionUrl__PGi+M","pageWrapper":"admin_pageWrapper__2tnLR","nameWrapper":"admin_nameWrapper__1MM1J","input":"admin_input__KJRls"};